import Vue from 'vue';
import Router from 'vue-router';

import LandingNavbar from './layout/LandingNavbar.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';

import Landing from './pages/Landing.vue';

import Galleries from './pages/Galleries.vue';
import Gallery from './pages/Gallery.vue';
import Imprint from './pages/Imprint.vue';
import Buy from './pages/Buy.vue';
import About from './pages/About.vue';
import Trips from './pages/Trips.vue';

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      components: { default: Landing, header: LandingNavbar },
      props: {
        footer: { backgroundColor: 'black' },
      },
      meta: {
        title: 'Home',
        metaTags: [
          {
            name: 'description',
            content: 'I am Mathias',
          },
          {
            property: 'og:description',
            content: 'The home page of our example app.',
          },
        ],
      },
    },
    {
      path: '/about',
      name: 'about',
      components: { default: About, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        title: 'About',
      },
    },
    {
      path: '/imprint',
      name: 'imprint',
      components: { default: Imprint, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        title: 'Imprint',
      },
    },
    {
      path: '/buy',
      name: 'buy',
      components: { default: Buy, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        title: 'Buy',
      },
    },
    {
      path: '/gallery',
      name: 'gallery',
      components: { default: Galleries, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        title: 'Galleries',
      },
    },
    {
      path: '/gallery/:id',
      name: 'gallery-detail',
      components: { default: Gallery, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        type: 'gallery',
        title: 'Gallery',
      },
    },
    {
      path: '/trips',
      name: 'trips',
      components: { default: Trips, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        title: 'Trips',
      },
    },
    {
      path: '/trip/:id',
      name: 'gallery-detail',
      components: { default: Gallery, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 350 - 72 },
        footer: { backgroundColor: 'black' },
      },
      meta: {
        type: 'trip',
        title: 'Trips',
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    }
      return { x: 0, y: 0 };
  },
});

// This callback runs before every route change, including on page load.
// https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
// router.beforeEach((to, from, next) => {
//   // This goes through the matched routes from last to first, finding the closest route with a title.
//   // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
//   const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
//
//   // Find the nearest route element with meta tags.
//   const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);
//
//   let title;
//   if (to.name === 'gallery-detail' && to.params.id) {
//     // If a gallery is opened take the name of the gallery
//     title = galleries[to.params.id].name;
//   } else if (nearestWithTitle) {
//     // If a route with a title was found, set the document (page) title to that value.
//     title = nearestWithTitle.meta.title;
//   }
//
//   document.title = `${title} | mathiasmoeller.com`;
//
//   // Remove any stale meta tags from the document using the key attribute we set below.
//   Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) => el.parentNode.removeChild(el));
//
//   // Skip rendering meta tags if there are none.
//   if (!nearestWithMeta) return next();
//
//   // Turn the meta tag definitions into actual elements in the head.
//   nearestWithMeta.meta.metaTags.map((tagDef) => {
//     const tag = document.createElement('meta');
//
//     Object.keys(tagDef).forEach((key) => {
//       tag.setAttribute(key, tagDef[key]);
//     });
//
//     // We use this to track which meta tags we create, so we don't interfere with other ones.
//     tag.setAttribute('data-vue-router-controlled', '');
//
//     return tag;
//   })
//   // Add the meta tags to the document head.
//   .forEach((tag) => document.head.appendChild(tag));
//
//   return next();
// });

export default router;
